export default __webpack_public_path__ + "static/media/staking-background-1.341bcf21.png";